export const forcadeVendasMock = [[
{
    "isSuccess": true,
    "data": [
        [
            {
                "id": 1077,
                "codigoVendedor": "251281",
                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                "basesForcaVenda": [
                    {
                        "id": 20260901,
                        "data": "2026-09-01T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260903,
                        "data": "2026-09-03T00:00:00",
                        "totalVisitasValidas": 11
                    },
                    {
                        "id": 20260917,
                        "data": "2026-09-17T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260914,
                        "data": "2026-09-14T00:00:00",
                        "totalVisitasValidas": 22
                    },
                    {
                        "id": 20260923,
                        "data": "2026-09-23T00:00:00",
                        "totalVisitasValidas": 13
                    },
                    {
                        "id": 20260929,
                        "data": "2026-09-29T00:00:00",
                        "totalVisitasValidas": 11
                    },
                    {
                        "id": 20260909,
                        "data": "2026-09-09T00:00:00",
                        "totalVisitasValidas": 8
                    },
                    {
                        "id": 20260925,
                        "data": "2026-09-25T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260911,
                        "data": "2026-09-11T00:00:00",
                        "totalVisitasValidas": 14
                    },
                    {
                        "id": 20260921,
                        "data": "2026-09-21T00:00:00",
                        "totalVisitasValidas": 21
                    },
                    {
                        "id": 20260924,
                        "data": "2026-09-24T00:00:00",
                        "totalVisitasValidas": 14
                    },
                    {
                        "id": 20260904,
                        "data": "2026-09-04T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260928,
                        "data": "2026-09-28T00:00:00",
                        "totalVisitasValidas": 22
                    },
                    {
                        "id": 20260918,
                        "data": "2026-09-18T00:00:00",
                        "totalVisitasValidas": 21
                    },
                    {
                        "id": 20260922,
                        "data": "2026-09-22T00:00:00",
                        "totalVisitasValidas": 11
                    },
                    {
                        "id": 20260902,
                        "data": "2026-09-02T00:00:00",
                        "totalVisitasValidas": 3
                    },
                    {
                        "id": 20260910,
                        "data": "2026-09-10T00:00:00",
                        "totalVisitasValidas": 16
                    },
                    {
                        "id": 20260908,
                        "data": "2026-09-08T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260916,
                        "data": "2026-09-16T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260915,
                        "data": "2026-09-15T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260715,
                        "data": "2026-07-15T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260804,
                        "data": "2026-08-04T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260824,
                        "data": "2026-08-24T00:00:00",
                        "totalVisitasValidas": 20
                    },
                    {
                        "id": 20260720,
                        "data": "2026-07-20T00:00:00",
                        "totalVisitasValidas": 17
                    },
                    {
                        "id": 20260729,
                        "data": "2026-07-29T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260803,
                        "data": "2026-08-03T00:00:00",
                        "totalVisitasValidas": 22
                    },
                    {
                        "id": 20260706,
                        "data": "2026-07-06T00:00:00",
                        "totalVisitasValidas": 22
                    },
                    {
                        "id": 20260831,
                        "data": "2026-08-31T00:00:00",
                        "totalVisitasValidas": 21
                    },
                    {
                        "id": 20260730,
                        "data": "2026-07-30T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260821,
                        "data": "2026-08-21T00:00:00",
                        "totalVisitasValidas": 11
                    },
                    {
                        "id": 20260713,
                        "data": "2026-07-13T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260801,
                        "data": "2026-08-01T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260727,
                        "data": "2026-07-27T00:00:00",
                        "totalVisitasValidas": 22
                    },
                    {
                        "id": 20260820,
                        "data": "2026-08-20T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260702,
                        "data": "2026-07-02T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260703,
                        "data": "2026-07-03T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260806,
                        "data": "2026-08-06T00:00:00",
                        "totalVisitasValidas": 11
                    },
                    {
                        "id": 20260811,
                        "data": "2026-08-11T00:00:00",
                        "totalVisitasValidas": 15
                    },
                    {
                        "id": 20260701,
                        "data": "2026-07-01T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260812,
                        "data": "2026-08-12T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260722,
                        "data": "2026-07-22T00:00:00",
                        "totalVisitasValidas": 12
                    },
                    {
                        "id": 20260716,
                        "data": "2026-07-16T00:00:00",
                        "totalVisitasValidas": 12
                    },
                    {
                        "id": 20260818,
                        "data": "2026-08-18T00:00:00",
                        "totalVisitasValidas": 12
                    },
                    {
                        "id": 20260731,
                        "data": "2026-07-31T00:00:00",
                        "totalVisitasValidas": 14
                    },
                    {
                        "id": 20260817,
                        "data": "2026-08-17T00:00:00",
                        "totalVisitasValidas": 22
                    },
                    {
                        "id": 20260810,
                        "data": "2026-08-10T00:00:00",
                        "totalVisitasValidas": 13
                    },
                    {
                        "id": 20260819,
                        "data": "2026-08-19T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260828,
                        "data": "2026-08-28T00:00:00",
                        "totalVisitasValidas": 14
                    },
                    {
                        "id": 20260807,
                        "data": "2026-08-07T00:00:00",
                        "totalVisitasValidas": 11
                    },
                    {
                        "id": 20260717,
                        "data": "2026-07-17T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260825,
                        "data": "2026-08-25T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260826,
                        "data": "2026-08-26T00:00:00",
                        "totalVisitasValidas": 8
                    },
                    {
                        "id": 20260813,
                        "data": "2026-08-13T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260714,
                        "data": "2026-07-14T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260827,
                        "data": "2026-08-27T00:00:00",
                        "totalVisitasValidas": 13
                    },
                    {
                        "id": 20260728,
                        "data": "2026-07-28T00:00:00",
                        "totalVisitasValidas": 11
                    },
                    {
                        "id": 20260723,
                        "data": "2026-07-23T00:00:00",
                        "totalVisitasValidas": 8
                    },
                    {
                        "id": 20260721,
                        "data": "2026-07-21T00:00:00",
                        "totalVisitasValidas": 15
                    },
                    {
                        "id": 20260805,
                        "data": "2026-08-05T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260707,
                        "data": "2026-07-07T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260710,
                        "data": "2026-07-10T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260814,
                        "data": "2026-08-14T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260724,
                        "data": "2026-07-24T00:00:00",
                        "totalVisitasValidas": 8
                    },
                    {
                        "id": 20260601,
                        "data": "2026-06-01T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260608,
                        "data": "2026-06-08T00:00:00",
                        "totalVisitasValidas": 8
                    },
                    {
                        "id": 20260623,
                        "data": "2026-06-23T00:00:00",
                        "totalVisitasValidas": 6
                    },
                    {
                        "id": 20260612,
                        "data": "2026-06-12T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260615,
                        "data": "2026-06-15T00:00:00",
                        "totalVisitasValidas": 20
                    },
                    {
                        "id": 20260622,
                        "data": "2026-06-22T00:00:00",
                        "totalVisitasValidas": 11
                    },
                    {
                        "id": 20260605,
                        "data": "2026-06-05T00:00:00",
                        "totalVisitasValidas": 19
                    },
                    {
                        "id": 20260616,
                        "data": "2026-06-16T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260617,
                        "data": "2026-06-17T00:00:00",
                        "totalVisitasValidas": 8
                    },
                    {
                        "id": 20260618,
                        "data": "2026-06-18T00:00:00",
                        "totalVisitasValidas": 7
                    },
                    {
                        "id": 20260609,
                        "data": "2026-06-09T00:00:00",
                        "totalVisitasValidas": 11
                    },
                    {
                        "id": 20260619,
                        "data": "2026-06-19T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260611,
                        "data": "2026-06-11T00:00:00",
                        "totalVisitasValidas": 13
                    },
                    {
                        "id": 20260625,
                        "data": "2026-06-25T00:00:00",
                        "totalVisitasValidas": 14
                    },
                    {
                        "id": 20260624,
                        "data": "2026-06-24T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260626,
                        "data": "2026-06-26T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260602,
                        "data": "2026-06-02T00:00:00",
                        "totalVisitasValidas": 11
                    },
                    {
                        "id": 20260630,
                        "data": "2026-06-30T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260603,
                        "data": "2026-06-03T00:00:00",
                        "totalVisitasValidas": 12
                    },
                    {
                        "id": 20260610,
                        "data": "2026-06-10T00:00:00",
                        "totalVisitasValidas": 17
                    },
                    {
                        "id": 20260629,
                        "data": "2026-06-29T00:00:00",
                        "totalVisitasValidas": 8
                    },
                    {
                        "id": 1,
                        "cards": {
                            "id": 0,
                            "totalClientes": 291,
                            "visitasPresenciais": 12.145063388295798,
                            "visitasRemotas": 17.87105415642581,
                            "aderenciaRota": 0.9075309818875119,
                            "m300AderenciaRota": 0.9299999999999903,
                            "coberturaCarteira": 1,
                            "m300CoberturaCarteira": 0.8999999999999964
                        }
                    },
                    {
                        "id": 2,
                        "createdAt": "2026-10-01T07:45:14.8958535"
                    }
                ]
            },
            {
                "id": 892,
                "codigoVendedor": "234182",
                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                "basesForcaVenda": [
                    {
                        "id": 20260921,
                        "data": "2026-09-21T00:00:00",
                        "totalVisitasValidas": 22
                    },
                    {
                        "id": 20260903,
                        "data": "2026-09-03T00:00:00",
                        "totalVisitasValidas": 8
                    },
                    {
                        "id": 20260922,
                        "data": "2026-09-22T00:00:00",
                        "totalVisitasValidas": 3
                    },
                    {
                        "id": 20260917,
                        "data": "2026-09-17T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260901,
                        "data": "2026-09-01T00:00:00",
                        "totalVisitasValidas": 8
                    },
                    {
                        "id": 20260915,
                        "data": "2026-09-15T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260923,
                        "data": "2026-09-23T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260928,
                        "data": "2026-09-28T00:00:00",
                        "totalVisitasValidas": 22
                    },
                    {
                        "id": 20260914,
                        "data": "2026-09-14T00:00:00",
                        "totalVisitasValidas": 19
                    },
                    {
                        "id": 20260925,
                        "data": "2026-09-25T00:00:00",
                        "totalVisitasValidas": 12
                    },
                    {
                        "id": 20260911,
                        "data": "2026-09-11T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260924,
                        "data": "2026-09-24T00:00:00",
                        "totalVisitasValidas": 6
                    },
                    {
                        "id": 20260929,
                        "data": "2026-09-29T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260918,
                        "data": "2026-09-18T00:00:00",
                        "totalVisitasValidas": 12
                    },
                    {
                        "id": 20260902,
                        "data": "2026-09-02T00:00:00",
                        "totalVisitasValidas": 3
                    },
                    {
                        "id": 20260904,
                        "data": "2026-09-04T00:00:00",
                        "totalVisitasValidas": 6
                    },
                    {
                        "id": 20260831,
                        "data": "2026-08-31T00:00:00",
                        "totalVisitasValidas": 21
                    },
                    {
                        "id": 20260811,
                        "data": "2026-08-11T00:00:00",
                        "totalVisitasValidas": 6
                    },
                    {
                        "id": 20260828,
                        "data": "2026-08-28T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260812,
                        "data": "2026-08-12T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260819,
                        "data": "2026-08-19T00:00:00",
                        "totalVisitasValidas": 7
                    },
                    {
                        "id": 20260826,
                        "data": "2026-08-26T00:00:00",
                        "totalVisitasValidas": 13
                    },
                    {
                        "id": 20260824,
                        "data": "2026-08-24T00:00:00",
                        "totalVisitasValidas": 17
                    },
                    {
                        "id": 20260821,
                        "data": "2026-08-21T00:00:00",
                        "totalVisitasValidas": 13
                    },
                    {
                        "id": 20260806,
                        "data": "2026-08-06T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260827,
                        "data": "2026-08-27T00:00:00",
                        "totalVisitasValidas": 14
                    },
                    {
                        "id": 20260805,
                        "data": "2026-08-05T00:00:00",
                        "totalVisitasValidas": 12
                    },
                    {
                        "id": 20260813,
                        "data": "2026-08-13T00:00:00",
                        "totalVisitasValidas": 4
                    },
                    {
                        "id": 20260909,
                        "data": "2026-09-09T00:00:00",
                        "totalVisitasValidas": 8
                    },
                    {
                        "id": 20260818,
                        "data": "2026-08-18T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260916,
                        "data": "2026-09-16T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260820,
                        "data": "2026-08-20T00:00:00",
                        "totalVisitasValidas": 11
                    },
                    {
                        "id": 20260807,
                        "data": "2026-08-07T00:00:00",
                        "totalVisitasValidas": 7
                    },
                    {
                        "id": 20260810,
                        "data": "2026-08-10T00:00:00",
                        "totalVisitasValidas": 18
                    },
                    {
                        "id": 20260910,
                        "data": "2026-09-10T00:00:00",
                        "totalVisitasValidas": 6
                    },
                    {
                        "id": 20260825,
                        "data": "2026-08-25T00:00:00",
                        "totalVisitasValidas": 9
                    },
                    {
                        "id": 20260817,
                        "data": "2026-08-17T00:00:00",
                        "totalVisitasValidas": 18
                    },
                    {
                        "id": 20260908,
                        "data": "2026-09-08T00:00:00",
                        "totalVisitasValidas": 8
                    },
                    {
                        "id": 20260804,
                        "data": "2026-08-04T00:00:00",
                        "totalVisitasValidas": 22
                    },
                    {
                        "id": 20260801,
                        "data": "2026-08-01T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260814,
                        "data": "2026-08-14T00:00:00",
                        "totalVisitasValidas": 11
                    },
                    {
                        "id": 20260713,
                        "data": "2026-07-13T00:00:00",
                        "totalVisitasValidas": 21
                    },
                    {
                        "id": 20260717,
                        "data": "2026-07-17T00:00:00",
                        "totalVisitasValidas": 7
                    },
                    {
                        "id": 20260707,
                        "data": "2026-07-07T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260701,
                        "data": "2026-07-01T00:00:00",
                        "totalVisitasValidas": 12
                    },
                    {
                        "id": 20260706,
                        "data": "2026-07-06T00:00:00",
                        "totalVisitasValidas": 18
                    },
                    {
                        "id": 20260703,
                        "data": "2026-07-03T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260716,
                        "data": "2026-07-16T00:00:00",
                        "totalVisitasValidas": 12
                    },
                    {
                        "id": 20260714,
                        "data": "2026-07-14T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260610,
                        "data": "2026-06-10T00:00:00",
                        "totalVisitasValidas": 12
                    },
                    {
                        "id": 20260710,
                        "data": "2026-07-10T00:00:00",
                        "totalVisitasValidas": 8
                    },
                    {
                        "id": 20260601,
                        "data": "2026-06-01T00:00:00",
                        "totalVisitasValidas": 21
                    },
                    {
                        "id": 20260702,
                        "data": "2026-07-02T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260715,
                        "data": "2026-07-15T00:00:00",
                        "totalVisitasValidas": 8
                    },
                    {
                        "id": 20260708,
                        "data": "2026-07-08T00:00:00",
                        "totalVisitasValidas": 6
                    },
                    {
                        "id": 20260709,
                        "data": "2026-07-09T00:00:00",
                        "totalVisitasValidas": 6
                    },
                    {
                        "id": 20260602,
                        "data": "2026-06-02T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260629,
                        "data": "2026-06-29T00:00:00",
                        "totalVisitasValidas": 7
                    },
                    {
                        "id": 20260616,
                        "data": "2026-06-16T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260608,
                        "data": "2026-06-08T00:00:00",
                        "totalVisitasValidas": 7
                    },
                    {
                        "id": 20260630,
                        "data": "2026-06-30T00:00:00",
                        "totalVisitasValidas": 13
                    },
                    {
                        "id": 20260625,
                        "data": "2026-06-25T00:00:00",
                        "totalVisitasValidas": 5
                    },
                    {
                        "id": 20260617,
                        "data": "2026-06-17T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260622,
                        "data": "2026-06-22T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260619,
                        "data": "2026-06-19T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260605,
                        "data": "2026-06-05T00:00:00",
                        "totalVisitasValidas": 20
                    },
                    {
                        "id": 20260609,
                        "data": "2026-06-09T00:00:00",
                        "totalVisitasValidas": 12
                    },
                    {
                        "id": 20260615,
                        "data": "2026-06-15T00:00:00",
                        "totalVisitasValidas": 16
                    },
                    {
                        "id": 20260626,
                        "data": "2026-06-26T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260611,
                        "data": "2026-06-11T00:00:00",
                        "totalVisitasValidas": 10
                    },
                    {
                        "id": 20260618,
                        "data": "2026-06-18T00:00:00",
                        "totalVisitasValidas": 11
                    },
                    {
                        "id": 20260603,
                        "data": "2026-06-03T00:00:00",
                        "totalVisitasValidas": 13
                    },
                    {
                        "id": 20260624,
                        "data": "2026-06-24T00:00:00",
                        "totalVisitasValidas": 11
                    },
                    {
                        "id": 20260612,
                        "data": "2026-06-12T00:00:00",
                        "totalVisitasValidas": 5
                    },
                    {
                        "id": 1,
                        "cards": {
                            "id": 0,
                            "totalClientes": 287,
                            "visitasPresenciais": 11.161981090556658,
                            "visitasRemotas": 22.074658865234532,
                            "aderenciaRota": 0.8870967741935484,
                            "m300AderenciaRota": 0.9299999999999946,
                            "coberturaCarteira": 1,
                            "m300CoberturaCarteira": 0.8500000000000033
                        }
                    },
                    {
                        "id": 2,
                        "createdAt": "2026-10-01T07:45:14.9039537"
                    }
                ]
            },
            {
                "id": 1276,
                "codigoVendedor": "90121955",
                "nomeVendedor": "CLIENTE FECHADO",
                "basesForcaVenda": [
                    {
                        "id": 20260828,
                        "data": "2026-08-28T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260811,
                        "data": "2026-08-11T00:00:00",
                        "totalVisitasValidas": 2
                    },
                    {
                        "id": 20260701,
                        "data": "2026-07-01T00:00:00",
                        "totalVisitasValidas": 2
                    },
                    {
                        "id": 20260713,
                        "data": "2026-07-13T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260703,
                        "data": "2026-07-03T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260714,
                        "data": "2026-07-14T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260717,
                        "data": "2026-07-17T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260807,
                        "data": "2026-08-07T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260812,
                        "data": "2026-08-12T00:00:00",
                        "totalVisitasValidas": 2
                    },
                    {
                        "id": 20260722,
                        "data": "2026-07-22T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260813,
                        "data": "2026-08-13T00:00:00",
                        "totalVisitasValidas": 3
                    },
                    {
                        "id": 20260615,
                        "data": "2026-06-15T00:00:00",
                        "totalVisitasValidas": 2
                    },
                    {
                        "id": 20260610,
                        "data": "2026-06-10T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260603,
                        "data": "2026-06-03T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260618,
                        "data": "2026-06-18T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260602,
                        "data": "2026-06-02T00:00:00",
                        "totalVisitasValidas": 3
                    },
                    {
                        "id": 20260616,
                        "data": "2026-06-16T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260601,
                        "data": "2026-06-01T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260629,
                        "data": "2026-06-29T00:00:00",
                        "totalVisitasValidas": 2
                    },
                    {
                        "id": 1,
                        "cards": {
                            "id": 0,
                            "totalClientes": 20,
                            "visitasPresenciais": 14.380388911021612,
                            "visitasRemotas": 18.989136872688793,
                            "aderenciaRota": 1,
                            "m300AderenciaRota": 0.9299999999999998,
                            "coberturaCarteira": 1,
                            "m300CoberturaCarteira": 0.8734375000000001
                        }
                    },
                    {
                        "id": 2,
                        "createdAt": "2026-10-01T07:45:14.956645"
                    }
                ]
            },
            {
                "id": 1293,
                "codigoVendedor": "90121953",
                "nomeVendedor": "CLIENTE NÃO CONSOME BASICAS",
                "basesForcaVenda": [
                    {
                        "id": 20260703,
                        "data": "2026-07-03T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260708,
                        "data": "2026-07-08T00:00:00",
                        "totalVisitasValidas": 2
                    },
                    {
                        "id": 20260813,
                        "data": "2026-08-13T00:00:00",
                        "totalVisitasValidas": 2
                    },
                    {
                        "id": 20260722,
                        "data": "2026-07-22T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260710,
                        "data": "2026-07-10T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260707,
                        "data": "2026-07-07T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260805,
                        "data": "2026-08-05T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260717,
                        "data": "2026-07-17T00:00:00",
                        "totalVisitasValidas": 2
                    },
                    {
                        "id": 20260801,
                        "data": "2026-08-01T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260701,
                        "data": "2026-07-01T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260728,
                        "data": "2026-07-28T00:00:00",
                        "totalVisitasValidas": 0
                    },
                    {
                        "id": 20260729,
                        "data": "2026-07-29T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260831,
                        "data": "2026-08-31T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260818,
                        "data": "2026-08-18T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260716,
                        "data": "2026-07-16T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260724,
                        "data": "2026-07-24T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260612,
                        "data": "2026-06-12T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260602,
                        "data": "2026-06-02T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260601,
                        "data": "2026-06-01T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260611,
                        "data": "2026-06-11T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260608,
                        "data": "2026-06-08T00:00:00",
                        "totalVisitasValidas": 2
                    },
                    {
                        "id": 20260603,
                        "data": "2026-06-03T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260605,
                        "data": "2026-06-05T00:00:00",
                        "totalVisitasValidas": 2
                    },
                    {
                        "id": 20260629,
                        "data": "2026-06-29T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260617,
                        "data": "2026-06-17T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 20260609,
                        "data": "2026-06-09T00:00:00",
                        "totalVisitasValidas": 1
                    },
                    {
                        "id": 1,
                        "cards": {
                            "id": 0,
                            "totalClientes": 16,
                            "visitasPresenciais": 12.38155293889381,
                            "visitasRemotas": 18.84356035064061,
                            "aderenciaRota": 0.9285714285714286,
                            "m300AderenciaRota": 0.9299999999999999,
                            "coberturaCarteira": 1,
                            "m300CoberturaCarteira": 0.8861111111111111
                        }
                    },
                    {
                        "id": 2,
                        "createdAt": "2026-10-01T07:45:15.0415217"
                    }
                ]
            }
        ]
    ],
    "existentes": []
}
]]